import { CP_1700_GRAPHQL } from "@rccl/telemetry-metadata";

interface GQlTelemetryErrorCodes {
    [operation:string]: CP_1700_GRAPHQL;
}

const gqlTelemetryErrorCodes: GQlTelemetryErrorCodes = {
    WebCreateCartForPackageOrderModification : 'CP-1701-GRAPHQL-DINING_CREATE_CART_FOR_ORDER_MODIFICATION_UNEXPECTED_ERROR',
    WebAddItem: 'CP-1702-GRAPHQL-DINING_ADD_ITEM_UNEXPECTED_ERROR',
    WebRemoveItem : 'CP-1703-GRAPHQL-DINING_REMOVE_ITEM_UNEXPECTED_ERROR',
    WebProductsByPackage : 'CP-1704-GRAPHQL-DINING_PRODUCTS_BY_PACKAGES_UNEXPECTED_ERROR',
    GetGQLCategories: 'CP-1705-GRAPHQL-GET_CATEGORIES_UNEXPECTED_ERROR',
    WebOfferings: 'CP-1706-GRAPHQL-DINING_OFFERINGS_UNEXPECTED_ERROR',
    Default : 'CP-1700-GRAPHQL-UNEXPECTED_ERROR'
}

export function getTelemetryErrorCodePerOperation ( operationName: string ) : CP_1700_GRAPHQL {
    const code = gqlTelemetryErrorCodes[operationName] ?? gqlTelemetryErrorCodes['Default'];
    return code;
}
